module.exports = __webpack_public_path__ + "img/down.69577c85.svg";